<template>
  <div class="ibox-child">
    <div class="row">
      <div class="form-group col-sm-12 info-status">
        <div class="panel">
          <div class="public-body">
            <div class="">
              <label class="control-label status-label" for="status">{{$t('ShareLabelTitle')}}</label>
            </div>
            <div class="panel-footer info-add" v-if="okrType !== 'keyResult'">
              <!-- 公開範囲のリセット -->
              <span @click="emitPublic" class="btn btn-success add-public add-public"><i class="fa fa-plus"></i>{{$t('addStr')}}</span>
              <span @click="emitResetPublic" class="btn btn-primary add-public add-public">{{$t('popTitleStr12')}}</span>
            </div>
          </div>
          <div class="status-control">
            <div v-if="checkedUsers.length > 0" class="public-box">
              <ul>
                <!-- <li v-for="(user, key) in getCheckedUsersInfo" :key="user.id" v-if="user.userInfo.userName"> -->
                <li v-for="user in getCheckedUsersInfo" :key="user.id" v-if="user.userInfo.userName" class="public-cell">
                  <span class="public-userimg">
                    <img v-if="user.userInfo.userIcon" :src="user.userInfo.userIcon" alt="image" class="img-circle" />
                    <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle" />
                  </span>
                  <div class="public-userinfo">
                    <span class="public-username">{{user.userInfo.userName}}</span>
                  </div>
                  <span v-if="okrType !== 'keyResult'" @click="emitDeletePublicUser(user.userId)" class="reply-tag"><i class="fa fa-times cursor"></i></span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'RegistShare',
  components: {
  },
  computed: {
    ...mapGetters('users/', [
      'getUsersByIds'
    ]),
    getCheckedUsersInfo: function () {
      return this.getUsersByIds(this.checkedUsers)
    }
  },
  props: {
    checkedUsers: Array,
    okrType: {
      type: String,
      default: 'objective'
    }
  },
  data: function () {
    return {
    }
  },
  methods: {
    emitPublic: function () {
      this.$emit('open-share', 'share')
    },
    emitResetPublic: function () {
      this.$emit('reset-share')
    },
    emitDeletePublicUser: function (userId) {
      this.$emit('delete-share-user', userId)
    }
  },
  updated: function () {
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Regist/RegistShare.vue